import { create } from "zustand"
import { persist } from "zustand/middleware"

interface SidebarState {
  /** Whether the desktop sidebar is collapsed to an icon-only rail. */
  collapsed: boolean
  toggleCollapsed: () => void
  setCollapsed: (collapsed: boolean) => void
}

export const useSidebarStore = create<SidebarState>()(
  persist(
    (set) => ({
      collapsed: false,
      toggleCollapsed: () => set((state) => ({ collapsed: !state.collapsed })),
      setCollapsed: (collapsed) => set({ collapsed })
    }),
    {
      name: "sidebar-store"
    }
  )
)
